import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Modal } from 'antd';
import { accountCreate } from 'middleware/account/actions';
import { addUserDialog as addUserDialogStrings } from 'ui/constants/strings';
import AddUserForm from './addUserForm';

const styles = {
  addUserDialog: {
    borderRadius: 0,
  },
}

class AddUserDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: '',
      confirmPassword: '',
      displayName: '',
      disableAddButton: false,
    }
  }

  onAddUser = () => {
    const { accountCreate } = this.props;
    const { userName, password, displayName } = this.state;
    accountCreate(userName, password, displayName);
    this.onCloseAddUserDialog();
  }

  onCloseAddUserDialog = () => {
    const { onCancel } = this.props;
    onCancel();
  }
  
  onChange = (value, key) => {
    this.setState({
      [key]: value,
    });
  }

  renderUserCreateForm = () => {
    return (
      <AddUserForm
        onChangeUserName={value => this.onChange(value, 'userName')}
        onChangePassword={value => this.onChange(value, 'password')}
        onChangeConfirmPassword={value => this.onChange(value, 'confirmPassword')}
        onChangeDisplayName={value => this.onChange(value, 'displayName')}
      />
    )
  }

  render() {
    const { visible } = this.props;
    const { disableAddButton } = this.state;

    const title = (
      <div className='dialogTitle'>
      { addUserDialogStrings.title }
      </div>
    )
    const foorter = (
      <div className='dialogFooter'>
        <Button className='footerSaveButtin' onClick={this.onAddUser} disabled={disableAddButton}>
          { addUserDialogStrings.confirmButton }
        </Button>
        <Button className='footerCancelButton' onClick={this.onCloseAddUserDialog}>
          { addUserDialogStrings.cancelButton }
        </Button>
      </div>
    )

    return (
      <Modal
        style={styles.addUserDialog}
        centered
        visible={visible}
        maskClosable={false}
        title={title}
        destroyOnClose={true}
        footer={foorter}
        onCancel={() => this.onCloseAddUserDialog()}
        wrapClassName={'dialog-setting'}
      >
        { this.renderUserCreateForm() }
      </Modal>
    );
  }
}

AddUserDialog.defaultProps = {
};

AddUserDialog.propTypes = {
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      accountCreate,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(AddUserDialog);
